import type { ImportMetaLocation } from "@-/dev.improve.haniverse.lib.logger";
import { createContentFindFirstQuery } from "#create-content-find-first-query";
import { createContentFindManyQuery } from "#create-content-find-many-query";
import type { ContentQueryTable } from "#types";

export function createContentTableQueries<TTable extends ContentQueryTable>(
  location: ImportMetaLocation,
  table: TTable,
) {
  return {
    findFirst: createContentFindFirstQuery(location, table),
    findMany: createContentFindManyQuery(location, table),
  };
}
